import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

const LOADER_CHECK_INTERVAL = 500
const FORM_STABLE_TIME = 2000
const LOAD_TIMEOUT = 60000
const POPUP_STYLES_ID = "shopify-themes-quiz-styles"
const SENDPULSE_LOAD_ROOT_MARGIN = "800px 0px"

const POPUP_SHADOW_ROOT_STYLES = `
	/* SendPulse explicitly restores visibility inside its shadow tree. */
	:host(:not([data-quiz-ready])) .sp-popup,
	:host(:not([data-quiz-ready])) .sp-popup * {
		visibility: hidden !important;
	}

	.sp-inline-popup .sp-popup {
		width: 100% !important;
		background: none !important;
		box-shadow: none !important;
	}

	.sp-submit-animation {
		display: none !important;
	}

	.sp-inline-popup .sp-popup.sp-popup-custom-subscription.sp-popup-subscribe.sp-popup-theme-color {
		background-color: transparent !important;
	}

	.sp-popup-content {
		max-height: unset !important;
		justify-content: space-between;
		align-items: center;
		border-radius: 0 !important;
	}

	.sp-popup-info {
		justify-content: flex-start !important;
		max-width: 682px;
		padding: 0 80px 70px 0 !important;
	}

	.sp-popup-form {
		height: 100%;
		gap: 0 !important;
	}

	.sp-popup-form.disabled .sp-popup-form-item {
		opacity: 1 !important;
	}

	.sp-popup-title h2 {
		margin-bottom: 0 !important;
		font-family: "Inter", sans-serif;
		font-size: 40px;
		font-weight: 600 !important;
		line-height: 1.22 !important;
	}

	.sp-popup-title h3 {
		margin: 0 !important;
		font-family: "Inter", sans-serif;
		font-size: 24px;
		line-height: 1.2;
	}

	.sp-popup-title p {
		font-family: "Inter", sans-serif;
		font-size: 16px !important;
		font-weight: 400;
		line-height: 1.5 !important;
	}

	.sp-popup-title div {
		font-family: "Inter", sans-serif;
		font-size: 14px;
		line-height: 1.5;
	}

	.sp-radio,
	.sp-option {
		display: flex;
		flex-direction: column;
	}

	.sp-radio {
		gap: 4px;
	}

	.sp-option {
		gap: 2px;
	}

	.sp-popup-label-theme {
		display: flex !important;
		align-items: center;
		min-height: 28px !important;
		padding-left: 35px !important;
		font-family: "Inter", sans-serif;
		font-size: 16px !important;
		color: #5B5A54;
	}

	.sp-checkbox .sp-popup-label-theme {
		min-height: 26px !important;
	}

	.sp-inline-popup .sp-popup .sp-checkbox .checkbox .sp-popup-label-theme input[type=checkbox],
	.sp-inline-popup .sp-popup .sp-option .checkbox .sp-popup-label-theme input[type=checkbox] {
		width: 20px;
		height: 20px;
		border-color: #212326 !important;
		border-radius: 3px;
	}

	.sp-inline-popup .sp-popup .sp-checkbox .checkbox .sp-popup-label-theme input[type=checkbox]:checked,
	.sp-inline-popup .sp-popup .sp-option .checkbox .sp-popup-label-theme input[type=checkbox]:checked {
		background-color: #0F6241 !important;
		border-color: #0F6241 !important;
	}

	.sp-inline-popup .sp-popup .sp-checkbox .checkbox .sp-popup-label-theme input[type=checkbox]:checked:before,
	.sp-inline-popup .sp-popup .sp-option .checkbox .sp-popup-label-theme input[type=checkbox]:checked:before {
		background-color: transparent !important;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='10' viewBox='0 0 14 10' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.7157 0L5.18257 7.45797L1.28338 3.5977L0 4.86827L5.18257 10L14 1.27147L12.7157 0Z' fill='white'/%3E%3C/svg%3E");
	}

	.sp-inline-popup .sp-popup .sp-radio .radio .sp-popup-label-theme input[type=radio] {
		width: 22px;
		height: 22px;
		border-color: #212326 !important;
	}

	.sp-inline-popup .sp-popup .sp-checkbox .checkbox .sp-popup-label-theme input[type=checkbox]:before,
	.sp-inline-popup .sp-popup .sp-option .checkbox .sp-popup-label-theme input[type=checkbox]:before {
		width: 14px;
		height: 10px;
		background-color: #fff !important;
	}

	.sp-inline-popup .sp-popup .sp-radio .radio .sp-popup-label-theme input[type=radio]:before {
		width: 14px;
		height: 14px;
		box-shadow: inset 1em 1em #0F6241 !important;
	}

	.sp-popup-input {
		padding: 7px 0 !important;
		border: 1px solid transparent !important;
		border-bottom-color: #C1C2C3 !important;
		border-radius: 0 !important;
		background-color: transparent !important;
		font-family: "Inter", sans-serif !important;
		font-size: 16px !important;
	}

	.sp-inline-popup .sp-popup .sp-popup-form-error .sp-popup-input.invalid {
		border: 1px solid transparent !important;
		border-bottom-color: #f63d15 !important;
	}

	.sp-popup-input::placeholder {
		color: #87888A;
	}

	.sp-popup-input-placeholder {
		display: none !important;
	}

	.sp-inline-popup .sp-popup .error-text {
		margin: 0 !important;
	}

	.sp-inline-popup .sp-popup .sp-popup-form-button button {
		max-width: 265px;
		min-height: 50px !important;
		max-height: 50px !important;
		font-family: "Inter", sans-serif !important;
		font-size: 16px !important;
		font-weight: 600 !important;
		line-height: 1.5 !important;
		border-radius: 50px !important;
		transition: background-color .25s ease-out !important;
	}

	.sp-popup-form-button button:focus {
		box-shadow: none !important;
	}

	.sp-popup-form-button button:hover {
		background-color: #0A402B !important;
		opacity: 1 !important;
	}

	.sp-popup-main {
		align-self: flex-end;
		width: 49.306% !important;
	}

	.sp-popup-image {
		max-height: unset !important;
		height: 100% !important;
		border-radius: 0 !important;
		object-fit: contain !important;
	}

	.quiz-steps {
		display: none !important;
	}

	.sp-poweredby {
		display: none !important;
	}

	@media (max-width: 991px) {
		.sp-inline-popup .sp-popup-popup .sp-popup.sp-popup-subscribe .sp-popup-content {
			flex-direction: column-reverse !important;
		}

		.sp-popup-title h2 {
			font-size: 24px;
		}

		.sp-popup-title h3 {
			font-size: 18px;
		}

		.sp-popup-title div {
			font-size: 12px;
		}

		.sp-popup-label-theme {
			min-height: 23px !important;
			font-size: 14px !important;
		}

		.sp-inline-popup .sp-popup .sp-checkbox .checkbox .sp-popup-label-theme input[type=checkbox],
		.sp-inline-popup .sp-popup .sp-option .checkbox .sp-popup-label-theme input[type=checkbox],
		.sp-inline-popup .sp-popup .sp-radio .radio .sp-popup-label-theme input[type=radio] {
			width: 18px;
			height: 18px;
		}

		.sp-inline-popup .sp-popup .sp-radio .radio .sp-popup-label-theme input[type=radio]:before {
			width: 10px;
			height: 10px;
		}

		.sp-popup-main {
			width: 100% !important;
		}

		.sp-popup-info {
			max-width: 100%;
			padding: 0 15px !important;
		}

		.sp-popup-content {
			gap: 40px;
		}

		.sp-popup-form-item.sp-popup-form-text + .sp-popup-form-item.sp-popup-form-spacer {
			height: 28px !important;
		}

		.sp-popup-form-item.sp-popup-form-radio + .sp-popup-form-item.sp-popup-form-spacer,
		.sp-popup-form-item.sp-popup-form-checkbox + .sp-popup-form-item.sp-popup-form-spacer,
		.sp-popup-form-item.sp-popup-form-multiselect + .sp-popup-form-item.sp-popup-form-spacer {
			height: 22px !important;
		}

		.sp-inline-popup .sp-popup .sp-popup-form-button button {
			margin: 7px auto 0;
			min-height: 40px !important;
			max-height: 40px !important;
		}
	}

	@media (max-width: 480px) {
		.sp-inline-popup .sp-popup-popup .sp-popup .sp-popup-info {
			max-width: 100% !important;
		}
	}
`

const setShadowRootStyles = shadowRoot => {
  if (shadowRoot.querySelector(`#${POPUP_STYLES_ID}`)) {
    return
  }

  const style = document.createElement("style")

  style.id = POPUP_STYLES_ID
  style.textContent = POPUP_SHADOW_ROOT_STYLES

  shadowRoot.appendChild(style)
}

const resetConflictingSendPulseWidget = widgetId => {
  if (window.sp?.popups?.projectId === widgetId) {
    return
  }

  document.querySelectorAll("sp-popups").forEach(element => element.remove())

  if (window.sp?.popups) {
    delete window.sp.popups
  }
}

const loadSendPulseScript = ({ scriptSrc, widgetId } = {}) => {
  if (!scriptSrc || !widgetId) {
    return
  }

  resetConflictingSendPulseWidget(widgetId)

  const existingScript = document.querySelector(
    `script[data-chats-widget-id="${widgetId}"]`
  )

  if (existingScript) {
    return existingScript
  }

  const script = document.createElement("script")

  script.async = true
  script.src = scriptSrc
  script.setAttribute("data-chats-widget-id", widgetId)

  document.body.appendChild(script)
  return script
}

const ShopifyThemesQuiz = ({
  id,
  antiblockerMessage,
  antiblockerImage,
  sendPulse,
}) => {
  const sectionRef = useRef(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [isAntiblocker, setIsAntiblocker] = useState(false)
  const [isTimedOut, setIsTimedOut] = useState(false)

  // Reveal the shadow content only after React commits .loaded and restores
  // the host's normal positioning. The readiness measurement still works hidden.
  useEffect(() => {
    if (!isLoaded) return undefined

    const wrapper = sectionRef.current?.querySelector(".sp-inline-popup")
    wrapper?.setAttribute("data-quiz-ready", "")
    return () => wrapper?.removeAttribute("data-quiz-ready")
  }, [isLoaded])

  useEffect(() => {
    const section = sectionRef.current
    let script
    let timeoutId
    let lastGeometry = ""
    let stableSince = 0
    let intervalId
    let observer
    let hasStarted = false

    if (!section) {
      return undefined
    }

    const onScriptError = () => setIsAntiblocker(true)

    const initializeSendPulse = () => {
      if (hasStarted) {
        return
      }

      hasStarted = true
      script = loadSendPulseScript(sendPulse)
      script?.addEventListener("error", onScriptError)
      timeoutId = window.setTimeout(() => setIsTimedOut(true), LOAD_TIMEOUT)

      intervalId = window.setInterval(() => {
        const wrapper = section.querySelector(".sp-inline-popup")
        const shadowRoot = wrapper?.shadowRoot

        if (!shadowRoot) return

        // Apply our layout while the host is invisible and outside document flow.
        setShadowRootStyles(shadowRoot)
        wrapper.classList.add("container")
        wrapper.style.display = "block"
        wrapper.style.maxWidth = "1280px"

        const content = shadowRoot.querySelector(".sp-popup-content")
        const button = shadowRoot.querySelector(".sp-popup-form-button button, button")
        const images = Array.from(shadowRoot.querySelectorAll("img"))
        const stylesheets = Array.from(shadowRoot.querySelectorAll('link[rel="stylesheet"]'))
        if (
          !content || !button || !content.getBoundingClientRect().height ||
          images.some(image => !image.complete) ||
          stylesheets.some(link => !link.sheet) ||
          document.fonts?.status === "loading"
        ) {
          stableSince = 0
          return
        }

        // Watch internal geometry too: the outer height alone can stay constant
        // while SendPulse moves its illustration and text between columns.
        const geometry = [wrapper, content, ...content.querySelectorAll("*")]
          .map(element => {
            const rect = element.getBoundingClientRect()
            return [rect.x, rect.y, rect.width, rect.height].map(Math.round).join(",")
          }).join(";")
        const now = performance.now()
        if (geometry !== lastGeometry || !stableSince) {
          lastGeometry = geometry
          stableSince = now
          return
        }
        if (now - stableSince < FORM_STABLE_TIME) return

        setIsLoaded(true)
        setIsAntiblocker(false)
        setIsTimedOut(false)
        window.clearTimeout(timeoutId)
        script?.removeEventListener("error", onScriptError)
        window.clearInterval(intervalId)
      }, LOADER_CHECK_INTERVAL)
    }

    if (!("IntersectionObserver" in window)) {
      initializeSendPulse()
    } else {
      observer = new IntersectionObserver(
        entries => {
          if (!entries.some(entry => entry.isIntersecting)) {
            return
          }

          observer.disconnect()
          initializeSendPulse()
        },
        { rootMargin: SENDPULSE_LOAD_ROOT_MARGIN }
      )

      observer.observe(section)
    }

    return () => {
      observer?.disconnect()
      window.clearTimeout(timeoutId)
      script?.removeEventListener("error", onScriptError)

      if (intervalId) {
        window.clearInterval(intervalId)
      }
    }
  }, [sendPulse])

  const quizClasses = classNames("quiz", {
    loaded: isLoaded,
    "quiz--antiblocker": isAntiblocker,
  })
  const loaderClasses = classNames(
    "quiz__loader-wrapper",
    {
      hidden: isAntiblocker || isTimedOut,
    }
  )
  const antiblockerMessageClasses = classNames(
    "quiz__antiblocker-message",
    {
      hidden: !isAntiblocker && !isTimedOut,
    }
  )

  return (
    <section id={id} className={quizClasses} ref={sectionRef}>
      <div className={loaderClasses}>
        <div className="quiz__loader" />
      </div>

      <div className={antiblockerMessageClasses}>
        <p>
          {(isTimedOut && !isAntiblocker
            ? ["The quiz is taking longer to load. Please wait or reload the page."]
            : antiblockerMessage).map((line, index) => (
            <React.Fragment key={line}>
              {index > 0 ? <br /> : null}
              {line}
            </React.Fragment>
          ))}
        </p>

        {isAntiblocker ? (
          <img
            src={antiblockerImage.src}
            alt={antiblockerImage.alt}
            width={antiblockerImage.width}
            height={antiblockerImage.height}
            loading="lazy"
            decoding="async"
          />
        ) : null}
      </div>
    </section>
  )
}

ShopifyThemesQuiz.propTypes = {
  id: PropTypes.string.isRequired,
  antiblockerMessage: PropTypes.arrayOf(PropTypes.string).isRequired,
  antiblockerImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  sendPulse: PropTypes.shape({
    scriptSrc: PropTypes.string.isRequired,
    widgetId: PropTypes.string.isRequired,
  }).isRequired,
}

export default ShopifyThemesQuiz
